import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import { ISkidMission } from 'src/app/storage/interfaces/skid-mission.interface';
import { ISkid } from 'src/app/storage/interfaces/skid.interface';
import { SkidMission } from 'src/app/storage/models/skid-mission.model';
import { Skid } from 'src/app/storage/models/skid.model';
import { environment } from 'src/environments/environment';
import { ApiService } from './api.service';

const URL = environment.aws.amplify.API.REST;

@Injectable({
  providedIn: 'root'
})
export class SkidsService {

  missionSkids$: BehaviorSubject<SkidMission[]> = new BehaviorSubject(null);
  skids$: BehaviorSubject<Skid[]> = new BehaviorSubject(null);

  constructor(
    private translateService: TranslateService,
    private apiService: ApiService
  ) { }

  async getSkids(marketname: string): Promise<Skid[] | null> {
    const translations = await this.translateService.get('SKIDS').toPromise();

    const response = await this.apiService.get(
      `${URL}skids/market/${marketname}`,
      translations['LABEL']
    );

    return response ?
          response.skids.map((skid: ISkid) => new Skid(skid)) :
          null;
  }

  async getMissionSkids(missionId: string): Promise<SkidMission[] | null> {
    const translations = await this.translateService.get('SKIDS').toPromise();

    const response = await this.apiService.get(
      `${URL}skids/mission/${missionId}`,
      translations['LABEL']
    );

    return response ?
          response.skids.map((missionSkid: ISkidMission) => new SkidMission(missionSkid)) :
          null;
  }

  async addUpdateMissionSkid(missionId: string, missionSkid: SkidMission, injectionpk?: number, trainpk?: number): Promise<boolean> {
    const translations = await this.translateService.get('SKIDS').toPromise();

    const payload = {
      skidId: missionSkid.skidId,
      pumpId: missionSkid.pumpId != null ? missionSkid.pumpId : missionSkid.skid?.pumpId,
      gatewayId: missionSkid.gatewayId != null ? missionSkid.gatewayId : missionSkid.skid?.gatewayId,
      flowmeterId: missionSkid.flowmeterId != null ? missionSkid.flowmeterId : missionSkid.skid?.flowmeterId,
      fieldprotocolName: missionSkid.fieldprotocolName,
      ...(injectionpk != null ? {injectionpk} : {}),
      ...(trainpk != null ? {trainpk} : {})
    };

    const response = await this.apiService.post(
      `${URL}skids/mission/${missionId}`,
      payload,
      translations['LABEL'],
      { showLoader: true }
    );

    return response != null;
  }

  async removeMissionSkid(missionId: string, skidId: string): Promise<boolean> {
    const translations = await this.translateService.get('ANALYZERS').toPromise();

    const response = await this.apiService.delete(
      `${URL}skids/mission/${missionId}/${skidId}`,
      translations['LABEL'],
      { showLoader: true }
    );

    return response != null;
  }
}
